import {config as sourceEngagementConfig} from './SourceEngagement';
import {config as activityTypeConfig} from './ActivityType';
import {config as objectImpactedConfig} from './ObjectImpacted';
import {config as relatedObjectImpactedConfig} from './RelatedObjectImpacted';
import {config as relatedSecondaryObjectImpactedConfig} from './RelatedSecondaryObjectImpacted';
import {config as activityDateConfig} from './ActivityDate';

export default (labels) => [
	sourceEngagementConfig(labels),
	activityTypeConfig(labels),
	objectImpactedConfig(labels),
	relatedObjectImpactedConfig(labels),
	relatedSecondaryObjectImpactedConfig(labels),
	activityDateConfig(labels)
];
